<template>
  <v-app id="app">
    <Header/>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import Header from './components/Header.vue';
export default {
  components: {
    Header,
  }
};
</script>

<style scoped>
p {
  font-size: 4em;
  text-align: center;
}
</style>
